<script>
import { sleep } from '@/util'
import loanApi from '@/api/now/loanApi'

export default {
  props: {
    loading: {
      type: Boolean,
    },
    offer: {
      type: Object,
    },

    /**
     * {
     *    loanType: 'woori_crowd',
     *    repaymentPeriodInDays: 180,
     *  }
     */
    options: {
      type: Object,
      required: true,
    },
  },
  watch: {
    offer: {
      deep: true,
      immediate: true,
      async handler(v) {
        this.$emit('update:loading', true)
        if (!v || v?.status === 'in_progress') {
          const { data } = await loanApi.getLoansOffersCurrent(this.options)
          if (data.status === 'in_progress') {
            await sleep(5000)
          }
          this.$emit('update:offer', data)
          return
        }
        this.$emit('completed', v)
        this.$emit('update:loading', false)
      },
    },
  },
  render() {
    return this.$scopedSlots.default({
      offer: this.offer,
      amount: this.offer?.amount,
      loading: this.loading,
    })
  },
}
</script>

<style lang="scss" scoped></style>
